/**
 * Typed functions for `/api/users` endpoints.
 *
 * Source of truth for paths: src/api/routes/users.ts
 */

import { apiGet, apiPost } from './client';
import type {
  BanStatusResponse,
  FindByUsernameResponse,
  ReputationResponse,
  UpdateWalletBody,
  UserResponse,
} from './types';

/** GET /users/me - the authenticated user's profile. */
export async function getMe(): Promise<UserResponse> {
  return apiGet<UserResponse>('/users/me');
}

/** GET /users/me/reputation - lean reputation badge payload. */
export async function getMyReputation(): Promise<ReputationResponse> {
  return apiGet<ReputationResponse>('/users/me/reputation');
}

/** GET /users/me/ban-status */
export async function getMyBanStatus(): Promise<BanStatusResponse> {
  return apiGet<BanStatusResponse>('/users/me/ban-status');
}

/** POST /users/wallet - link or replace the caller's TON address. */
export async function updateWallet(body: UpdateWalletBody): Promise<UserResponse> {
  return apiPost<UserResponse>('/users/wallet', body);
}

/**
 * GET /users/by-username/:username - resolve a Telegram @handle.
 * Returns 200 with `{ user: null }` when no row matches.
 */
export async function findByUsername(username: string): Promise<FindByUsernameResponse> {
  return apiGet<FindByUsernameResponse>(
    `/users/by-username/${encodeURIComponent(username)}`,
  );
}
